export default __webpack_public_path__ + "static/media/Sabres.39bd0a18.png";